export default function (props: any) {
    return (
        <svg width="13" height="12" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g stroke="#2673FF" strokeWidth="1.5" fill="none" fillRule="evenodd">
                <path d="M14.28 14.813V6.328H5.795M14.128 6.48l-9.193 9.192" />
            </g>
        </svg>
    );
}
